import * as z from 'zod';

export const ForgotPasswordSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Enter correct Email Address to verify.'),
});

export type ForgotPasswordFormSchemaPayload = z.infer<typeof ForgotPasswordSchema>;
